import React, { useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'

import {
  Title,
  Button,
  Description,
  Space,
  Switch,
  Text
} from '@sart/components'
import { Confirmation } from '@sart/icons'
import { colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import client, { useClient } from '@sart/client'
import { testID } from '@sart/utilities'

export default function CheckoutConfirmation(props) {
  const {
    cache
  } = useClient()

  const { navigation, route } = props
  
  const content = useContent()
  
  const products = route.params?.productsPurchased
  const containsADTItem = hasAdtItem(products)

  function hasAdtItem(products) {
    let adtProduct = products?.find((product) => hasAdtTag(product))
    return adtProduct !== undefined
  }

  function hasAdtTag(product) {
    return (product.tags !== undefined && product.tags !== null && product.tags.find(tag => tag.tag === "ADT") !== undefined)
  }
  const order = route.params?.order
  const productList = getProductList(products)
  const last4digits  = getLast4Digits()
  
  const [storedCard, setStoredCard] = useState(false)
  const [recurring, setRecurring] = useState(false)

  useEffect(() => {
    client.clearCachedPayment()
    // basketHelper.clearCacheBasket()
    client.setCache({basket: []})
    handleDisabled()
		checkAndCompleteNotification()
  },[])

  function getProductList(products) {
    var toReturn = ''
    if (products){
      for(var i = 0; i < products.length; i++) {
        if(toReturn === '') {
          toReturn = products[i].productName
          if(products[i].quantity !== undefined) {
            toReturn = toReturn + ' x' + products[i].quantity
          }
        } else {
          toReturn = toReturn + ', ' + products[i].productName + ' x' + products[i].quantity
        }
      }
  }
    return toReturn
  }

  // TODO: needs work to adapt to different currencies and languages
  function successMessage() {
    if (products[0].category === 'AddOn') {
      if (order.paymentMethod === 'cash') {
        return content.payment_confirm.cash1 + order.cashPayment.reference
      } else {
        return (
          content.payment_confirm.addOn1 +
          productList +
          content.payment_confirm.addOn2
          )
        }
      } else if (products[0].category === 'Recharge') {
        if (order.paymentMethod === 'cash') {
          return content.payment_confirm.cash1 + order.cashPayment.reference
        } else {
          return content.payment_confirm.topUp + '£' + order.total / 100
        }
      } else if (products[0].subCategory === 'PortIn') {
        return content.port.confirmationInstruction
      } else {
        return (
          content.payment_confirm.payBill1 +
          '£' +
          order.serviceAddItems[0].total / 100
          )
        }
      }
      
  function getMessageTitle() {
    if (products[0].subCategory === 'PortIn'){
      return content.port.confirmationTitle
    } else if (order.paymentMethod === 'cash'){
      return content.payment_confirm.almostDone
    } else {
      return content.payment_confirm.done
    }
  }

  function handleDisabled() {
    for(var i = 0; i < products.length; i++) {
      if(products[i].recurring === true) {
        setRecurring(true)
        setStoredCard(true)
      } else {
        setRecurring(false)
        setStoredCard(false)
      }
    }
  }

	function checkAndCompleteNotification() {
		if(client.cache.promoNotification !== undefined) {
			let notification = client.cache.promoNotification
			let promoProductPurchased = false
			let ppp = notification.ppp
			if (ppp !== undefined && ppp.length > 0) {
				for(var j = 0; j < ppp.length; j++) {
					for(var i = 0; i < products.length; i++) {
						if(ppp[j].productId === products[i].productId) {
							promoProductPurchased = true
						}
					}
				}
			}
			if (promoProductPurchased) {
				// updateNotificationStatus(notification, 'completed')
			}
			client.unsetCache("promoNotification")

		}
	}

  function getLast4Digits() {
    if(order && order.paymentAuthorization && order.paymentAuthorization.tokenDetails) {
      var tokenDetails = JSON.parse(order.paymentAuthorization.tokenDetails)
      return tokenDetails.tokenizedCard.last4Digits
    } else {
      return ''
    }
  }

  function handleStoredCard(value) {
    setStoredCard(value)
  }

  async function storeCard() {
    let tokeniseProducts = await client.callApi('catalog','getTokenizeCardProducts',[client.cache.catalogId])
    const saveProduct = tokeniseProducts.find(
      product => product.productLegacyId === 'SAVE-VALIDATED-PAYMENT-CARD'
    )
    //set up extended data
    const extendedData = {
      validationOrder:{
        orderRefId:order.orderRefId
      }
    }
    //do transaction
    let saveOrder = await client.checkoutCustomerProductNoPayment(saveProduct,extendedData)
    if(saveOrder.status === 'successful') {
      console.log('Card Saved')
      client.loadPaymentPreference()
    }
  }

  return (
    <View style={styles.container}>
      <Space height={24} />
      <Confirmation color={colors.srGreen}/>
      <Space height={2 * 24} />

      <Title style={styles.title}>
        {getMessageTitle()}
      </Title>

      <Space height={24} />

      <Description style={styles.description}>{successMessage()} </Description>

      <Space height={24} />
      <View style={styles.storedCard}>
        {client.cache.language === 'en' && 
          <Description style={styles.description}>{content.checkout.saveCardEnglish}</Description>
        }
        {client.cache.language === 'es' && 
          <Description style={styles.description}>{content.checkout.saveCardSpanish} {last4digits} {content.checkout.saveCardSpanishTwo}</Description>
        }
        <Space width={8} />
        <Switch
          value={storedCard}
          disabled={recurring}
          onValueChange={(value) => handleStoredCard(value)}
          trackColor={{true: colors.srDarkGreen, false: colors.trivial}}
          ios_backgroundColor={colors.trivial}          
          thumbColor={colors.white}
        />
      </View>

      {containsADTItem &&
        <View>
          <Space height={24} />

          <Text style={styles.description}>{content.payment_confirm.adtInstruction}</Text>
        </View>
      }

      <Space height={24} />

      <Button
        style={styles.button}
        title={!storedCard ? content.payment_confirm.action : content.payment_confirm.saveAndReturn}
        onPress={() => {
          if(storedCard) {
            storeCard()
          }
          navigation.popToTop()
          navigation.navigate('Dashboard')
        }}
        titleStyle={{...typography.extrabold, fontSize: 18}}
        { ...testID('checkoutConfirmationButton')}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.srGreen
  },
  description: {
    textAlign: 'center',
    color: colors.srGreen, 
  },
  button: {
    alignSelf: 'stretch',
    backgroundColor:colors.srGreen
  },
  storedCard: {
    alignContent: 'center',
    flexDirection: 'row'
  }
})
